import { render, staticRenderFns } from "./CajasRegalo.vue?vue&type=template&id=1b1ee955"
import script from "./CajasRegalo.vue?vue&type=script&lang=js"
export * from "./CajasRegalo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports